import { render, staticRenderFns } from "./CustomerSignUp.vue?vue&type=template&id=763de5f0&"
import script from "./CustomerSignUp.vue?vue&type=script&lang=js&"
export * from "./CustomerSignUp.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSignUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports